import { Loading } from '@/components/Loading'
import { StepCompleteWrapper } from '@/containers/steps/vehicle/extra/StepComplete/StepCompleteWrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'

const StepCompletePageComponent = () => {
  const {
    insuranceParamsId: paramsId,
    isLoadingData,
    insuranceParams,
  } = useInsuranceParams()

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData && <Loading large={true} />}

          {!isLoadingData && insuranceParams && (
            <MeetingRecordProvider insuranceParamsId={paramsId!}>
              <OffersAddonProvider>
                <SelectedOffersAddonProvider>
                  <StepCompleteWrapper />
                </SelectedOffersAddonProvider>
              </OffersAddonProvider>
            </MeetingRecordProvider>
          )}
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const StepCompletePage = WithAuth(StepCompletePageComponent)
